import jquery from "jquery"; // Angular won't be set up when we need to use this, so fall back to JQuery.

import TbAppConfig from "./TbAppConfig";
import TbAppConfigError from "./TbAppConfigError";

const tbAppConfigLocation = "/config/tbconfiguration.json";

class TbAppConfigFactory {
    constructor() {}

    CreateFromKnownConfigLocationAsync() {
        return this.CreateFromUrlAsync(tbAppConfigLocation);
    }

    CreateFromUrlAsync(tbConfigUrl) {
        if (tbConfigUrl == null) {
            throw new TbAppConfigError("Invalid or missing configuration url", null);
        }

        const appConfigPipelineBuilder = (flowPromise) => flowPromise
            .then((configUrl) => jquery.get(configUrl))
            .then((configData) => new TbAppConfig(configData))
            .catch((errorData) => {
                throw new TbAppConfigError("Error loading configuration", errorData);
            });

        return appConfigPipelineBuilder(Promise.resolve(tbConfigUrl));
    }
}

export default TbAppConfigFactory;



//////////////////
// WEBPACK FOOTER
// ./src/config/tb-app-config/TbAppConfigFactory.js
// module id = EB9q
// module chunks = 1